import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { map, first } from 'rxjs/operators';
import { ISearchableOption } from '@emm/core/modules/cfa-data-table/models/ISearchOption';
import { CfaDataTable } from '@emm/core/modules/cfa-data-table/cfa-data-table.component';
import { IDataTableColumn, IEpochColumn } from '@emm/core/modules/cfa-data-table/models/IDataColumn';
import { IFilterOption } from '@emm/core/modules/cfa-data-table/models/IFilterOption';
import { Observable } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { MasterMenuFacadeService } from '@emm/management/services/master-menu-facade.service';

@Component({
    selector: 'emm-edit-location-dialog',
    templateUrl: './edit-location-dialog.component.html',
    styleUrls: ['./edit-location-dialog.component.scss'],
    animations: [
        trigger('shrinkForTimeline', [
            state('normal', style({ paddingLeft: '0px', paddingRight: '0px', paddingTop: '0px' })),
            state('timeline', style({ paddingLeft: '125px', paddingRight: '0px', paddingTop: '0px' })),
            state('filter', style({ paddingLeft: '0px', paddingRight: 'min(240px, 75%)', paddingTop: '0px' })),
            state('search', style({ paddingLeft: '0px', paddingRight: '0px', paddingTop: '80px' })),
            transition('* => timeline', animate('120ms cubic-bezier(0, 0, 0.2, 1)')),
            transition('* => filter', animate('120ms cubic-bezier(0, 0, 0.2, 1)')),
            transition('* => normal', animate('120ms cubic-bezier(0, 0, 0.2, 1)')),
            transition('* => search', animate('120ms cubic-bezier(0, 0, 0.2, 1)'))
        ]),
        trigger('slideInTimeline', [
            state('inactive', style({ opacity: '0', transform: 'translateX(-100%)' })),
            state('active', style({ opacity: '1', transform: 'none' })),
            transition('inactive => active', animate('120ms cubic-bezier(0, 0, 0.2, 1)')),
            transition('active => inactive', animate('120ms cubic-bezier(0, 0, 0.2, 1)'))
        ]),
        trigger('slideInFilters', [
            state('inactive', style({ opacity: '0', transform: 'translateX(100%)' })),
            state('active', style({ opacity: '1', transform: 'none' })),
            transition('inactive => active', animate('120ms cubic-bezier(0, 0, 0.2, 1)')),
            transition('active => inactive', animate('120ms cubic-bezier(0, 0, 0.2, 1)'))
        ]),
        trigger('fadeInSearch', [
            state('void', style({ opacity: '0' })),
            state('active', style({ opacity: '1' })),
            transition('void => active', animate('120ms cubic-bezier(0, 0, 0.2, 1)')),
            transition('active => void', animate('120ms cubic-bezier(0, 0, 0.2, 1)'))
        ])
    ],
    standalone: false
})
export class EditLocationDialogComponent implements OnInit {
  @ViewChild(CfaDataTable, { static: true }) dataTable: CfaDataTable<any>;
  public isLinear = true;
  selection = new SelectionModel<IDataTableColumn>(true, []);
  selectedLocations = this.data.selectedLocations;
  private locationPaneFilter: IFilterOption = {
    columnLabel: 'Number',
    columnProperty: 'tag',
    options: [],
    filtered: []
  };

  allDTOMallFSULocations$ = this.masterMenuFacade.allDTOMallFSULocations$;
  filterOptions: IFilterOption[] = [
    this.locationPaneFilter
  ];
  searchableOptions: ISearchableOption[] = [
    { columnLabel: 'All Columns', columnProperty: null }
  ];
  dataColumns: IDataTableColumn[] = [
    {
      label: 'Name',
      property: 'name',
      width: '200px'
    },
    {
      label: 'Number',
      property: 'tag',
      width: '80px'
    },
    {
      label: 'Country Code',
      property: 'countryCode',
      width: '80px'
    }
  ];

  epochColumn: IEpochColumn = {
    label: 'Date/Time',
    sortProperty: 'audit_timestamp',
    displayProperty: 'audit_timestamp_string',
    width: '180px'
  };

  constructor(
    public dialogRef: MatDialogRef<EditLocationDialogComponent>,
    private masterMenuFacade: MasterMenuFacadeService,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.dialogRef.updatePosition({ top: '100px' });
  }

  getData(end: number, skipCache?: boolean): Observable<any[]> {
    if (skipCache) {
      this.locationPaneFilter.options = [];
    }
    return this.allDTOMallFSULocations$.pipe(
      first(),
      map(locations => {
        locations.forEach(log => {
          if (!this.locationPaneFilter.options.includes(log.tag)) {
            this.locationPaneFilter.options.push(log.tag);
          }
        });
        this.locationPaneFilter.options = this.locationPaneFilter.options.sort((a, b) => a.localeCompare(b));
        return locations;
      })
    );
  }

  getSelectedLocations(selected) {
    this.selectedLocations = selected;
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public closeAfterSave(): void {
    this.dialogRef.close(this.selectedLocations);
  }

  OnSubmit(){
    this.closeAfterSave();
  }
}
